import {Fragment, useEffect, useState} from 'react';
import {useGlobalState} from "../../GlobalStateProvider";
import {KeySolver} from "../../helper/KeySolver";

const Summary: (props: any) => JSX.Element = (props: any) => {

    const {state, setState} = useGlobalState();
    const {basePrice, rangeOfFluctuation, model} = props;

    const calculate = () => {
        let price: number = 0;
        if(state && state.summary && state.summary.length > 0) {
            for(let i in state.summary) {
                const item = state.summary[i];
                const calculation = item.calculation;

                if(calculation.percentage) {
                    if(calculation.calculationType === 'add') {
                        price = price + ((price / 100) * parseFloat(calculation.calculationValue));
                    }
                    if(calculation.calculationType === 'substract') {
                        price = price - ((price / 100) * parseFloat(calculation.calculationValue));
                    }
                } else {
                    if(calculation.calculationType === 'add') {
                        price = price + parseFloat(calculation.calculationValue);
                    }
                    if(calculation.calculationType === 'substract') {
                        price = price - parseFloat(calculation.calculationValue);
                    }
                }

            }
            setState({ ...state, total: price });
        }
    }

    useEffect(() => {
        calculate();
        console.log(state)
    }, []);

    return (
        <Fragment>
            <div className="hidden">
                <div className="flex flex-col gap-3">

                    <input type="text" name="request[properties][fullPrice]" value={state.total} onChange={() => { } } />
                    <input type="text" name="request[properties][basePrice]" defaultValue={basePrice} />
                    <input type="text" name="request[properties][rangeOfFluctuation]" defaultValue={rangeOfFluctuation} />
                    <input type="text" name="request[properties][model]" defaultValue={model} />

                    {state && state.summary && state.summary.length > 0 &&
                        <Fragment>
                            {state.summary.map((item: any, index: number) =>
                                <Fragment key={KeySolver()} >
                                    <input type="text" name={`request[properties][items][${item.parentTitle}][items][]`} value={item.title} onChange={() => { } } />
                                    {state && state.annotations && state.annotations.length > 0 && state.annotations.some((annotation: any) => annotation.index === item.index) &&
                                        <input type="text" name={`request[properties][items][${item.parentTitle}][annotation]`} value={state.annotations.find((annotation) => annotation.index === item.index).value} onChange={() => { } } />
                                    }
                                </Fragment>
                            )}
                        </Fragment>
                    }
                </div>
            </div>
        </Fragment>
    );
}

export default Summary;
